import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Plus } from "lucide-react";
import { Reveal } from "./Reveal";

const faqs = [
  {
    q: "Vocês atendem de madrugada e em feriados?",
    a: "Sim, 24 horas por dia, 7 dias por semana — incluindo madrugadas, domingos e feriados, sem taxa surpresa. O valor é informado antes do deslocamento.",
  },
  {
    q: "Como funciona o orçamento antes do atendimento?",
    a: "Você descreve o sintoma no WhatsApp, enviamos uma pré-análise e o valor fechado do deslocamento + diagnóstico. Peças e reparos só são executados com sua aprovação.",
  },
  {
    q: "As peças têm garantia?",
    a: "Todas as peças instaladas são novas, de primeiras marcas, com garantia escrita de 90 dias a 1 ano conforme o componente. O serviço de mão de obra também é garantido.",
  },
  {
    q: "Quais formas de pagamento são aceitas?",
    a: "Pix, cartão de crédito e débito (maquininha a bordo) e dinheiro. Frotistas podem fechar contrato mensal com faturamento.",
  },
  {
    q: "Atendem na chuva ou em rodovia?",
    a: "Sim. A unidade móvel é equipada para trabalho em pista, acostamento e condições adversas, com sinalização de segurança completa.",
  },
];

export default function FAQ() {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" data-testid="faq-section" className="relative py-24 sm:py-32">
      <div className="max-w-3xl mx-auto px-5 sm:px-8">
        <Reveal className="text-center">
          <p className="font-tech text-xs uppercase tracking-[0.25em] text-[#e8112d] font-semibold mb-4">
            Dúvidas frequentes
          </p>
          <h2 className="font-display font-bold tracking-tight text-2xl sm:text-3xl lg:text-4xl text-slate-100">
            Perguntas de quem está na pane
          </h2>
        </Reveal>

        <div className="mt-12 flex flex-col gap-3">
          {faqs.map((f, i) => (
            <Reveal key={i} delay={i * 0.06}>
              <div
                data-testid={`faq-accordion-item-${i}`}
                className={`rounded-xl border transition-colors duration-300 ${
                  open === i ? "border-[#e8112d]/40 bg-[#111318]" : "border-white/5 bg-[#0e1013]"
                }`}
              >
                <button
                  data-testid={`faq-trigger-${i}`}
                  onClick={() => setOpen(open === i ? -1 : i)}
                  className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left"
                >
                  <span className="text-sm sm:text-base font-semibold text-slate-100">{f.q}</span>
                  <Plus
                    className={`w-5 h-5 shrink-0 text-[#e8112d] transition-transform duration-300 ${
                      open === i ? "rotate-45" : ""
                    }`}
                  />
                </button>
                <AnimatePresence initial={false}>
                  {open === i && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
                      className="overflow-hidden"
                    >
                      <p className="px-6 pb-6 text-sm text-slate-400 leading-relaxed">{f.a}</p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
